import { render, staticRenderFns } from "./CompactEdit.vue?vue&type=template&id=85ac3974&"
import script from "./CompactEdit.vue?vue&type=script&lang=js&"
export * from "./CompactEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompactEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports